/**
 * MUI's default breakpoints (`@mui/material/styles`' `createTheme().breakpoints.values`).
 * `src/app/theme.js` is frozen and never overrode them, so the header hardcodes the same numbers
 * here rather than reading a (nonexistent) override from that legacy theme.
 */
export const BREAKPOINTS = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
} as const;

export type BreakpointKey = keyof typeof BREAKPOINTS;

/** Mobile-first `min-width` media query for one of the breakpoints above. */
export const up = (key: BreakpointKey): string => `@media (min-width: ${BREAKPOINTS[key]}px)`;

/**
 * Bar height per band (spec table). xs is the unconditional base value; sm covers sm AND md
 * (they share 64px), and lg covers lg AND xl (they share 72px) — see how these are consumed via
 * `up('sm')`/`up('lg')` in `index.tsx`.
 */
export const BAR_HEIGHT = {
  xs: 56,
  sm: 64,
  lg: 72,
} as const;
